'use client'

import React, { type PropsWithChildren } from 'react'

import { IamProvider } from '@hanzo/iam/react'
import { BRAND_SERVER_URLS } from '@hanzo/iam/paths'
import type { IAMConfig } from '@hanzo/iam/browser'

  /* These are Lux sites, so they sign in at Lux's own issuer. Naming another
    brand's would send a Lux user to a login page that has never heard of the
    redirect_uri they came from. */
const ORG = 'lux'

  /* Where the authorization code comes back. Every site mounts <Callback/> here. */
const CALLBACK = '/auth/callback'

  /* The OAuth client a site presents itself as: the `<org>-<app>` pair registered
    on lux.id, so lux.shop is `lux-shop`. */
const configure = (app: string): IAMConfig => ({
  serverUrl: BRAND_SERVER_URLS[ORG],
  organization: ORG,
  clientId: `${ORG}-${app}`,
    /* Read per render rather than at module load: one bundle serves the real
      host and any preview of it, and each must redeem its code back to itself. */
  redirectUri: (typeof window === 'undefined' ? '' : window.location.origin) + CALLBACK,
})

  /* Provider is memoized on the config's values, not its identity, so building a
    fresh object here does not rebuild the SDK. */
const Auth: React.FC<{ app: string } & PropsWithChildren> = ({ app, children }) => (
  <IamProvider config={configure(app)}>{children}</IamProvider>
)

export default Auth
